//
// Toggle Controller
//
// Toggles a class on an element.
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static classes = ['hidden']

  toggle(event) {
    event.preventDefault()
    this.contentTargets.forEach((el) => {

      el.classList.toggle(this.hiddenClass)
    })
  }
  hide(event) {
    event?.preventDefault()
    this.contentTargets.forEach((el) => {
      if (el.classList.contains(this.hiddenClass)) return
      el.classList.add(this.hiddenClass)
    })
  }
  show(event) {
    event?.preventDefault()
    this.contentTargets.forEach((el) => {
      if (!el.classList.contains(this.hiddenClass)) return
      el.classList.remove(this.hiddenClass)
    })
  }
}

